import {createSelector} from 'reselect';

import {AppParametricSelector} from '../../../helpers/reselectHelpers';
import {getAccounts} from '../../data/dataSelectors';

export function makeGetAccount(getAccountId: AppParametricSelector<any, number | undefined>) {
  return createSelector([getAccountId, getAccounts], (accountId, accounts) => {
    if (!accountId) {
      return undefined;
    }
    return accounts[accountId];
  });
}
